import React from "react";
import { useTranslation } from "react-i18next";
import "../scss/_donatePage.scss";

const Donate = () => {
    const { t } = useTranslation();

    return (
        <div className="donate-container">
            <div className="donate-content">
                <h1 className="donate-title">{t("donate-title")}</h1>
                <p className="donate-contact-info">
                    {t("donate-contact-info")}
                </p>
                <a href="mailto:rina.wehbe@dal.ca" className="donate-email">
                    rina.wehbe@dal.ca
                </a>
                <br></br>
                <a href="mailto:laura.clarke@dal.ca" className="donate-email">
                    laura.clarke@dal.ca
                </a>
            </div>
        </div>
    );
};

export default Donate;
